"use client"

import { useState, useEffect } from "react"
import { Menu, X } from "lucide-react"
import { motion } from "framer-motion"
import logo from '../assets/logo_verde_original.png'

const Header = () => {
  const [isOpen, setIsOpen] = useState(false)
  const [scrolled, setScrolled] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 50)
    }
    window.addEventListener("scroll", handleScroll)
    return () => window.removeEventListener("scroll", handleScroll)
  }, [])

  const smoothScrollTo = (elementId) => {
    const element = document.getElementById(elementId.toLowerCase())
    if (element) {
      element.scrollIntoView({
        behavior: "smooth",
        block: "start",
      })
    }
    setIsOpen(false)
  }

  const navItems = ["Inicio", "Servicios", "Clientes", "Nosotros", "Contacto"]

  return (
    <motion.header
      initial={{ y: -100 }}
      animate={{ y: 0 }}
      className={`fixed w-full z-50 transition-all duration-300 ${
        scrolled ? "bg-white/95 backdrop-blur-md shadow-sm border-b border-gray-200" : "bg-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex justify-between items-center py-2">
          <motion.div whileHover={{ scale: 1.02 }} className="flex items-center space-x-2">
            <img src={logo} alt="Mayma" className="h-14 w-auto" />
          </motion.div>

          {/* Desktop Navigation */}
          <nav className="hidden md:flex items-center space-x-8">
            {navItems.map((item) => (
              <motion.button
                key={item}
                onClick={() => smoothScrollTo(item)}
                whileHover={{ scale: 1.05 }}
                className="text-gray-700 hover:text-[#77c593] transition-colors duration-300 font-medium text-sm uppercase tracking-wide"
              >
                {item}
              </motion.button>
            ))}
          </nav>

          {/* Mobile menu button */}
          <div className="md:hidden">
            <button onClick={() => setIsOpen(!isOpen)} className="text-gray-700 hover:text-[#77c593] transition-colors">
              {isOpen ? <X size={24} /> : <Menu size={24} />}
            </button>
          </div>
        </div>

        {/* Mobile Navigation */}
        {isOpen && (
          <motion.div
            initial={{ opacity: 0, y: -20 }}
            animate={{ opacity: 1, y: 0 }}
            className="md:hidden bg-white/95 backdrop-blur-md rounded-lg mt-2 p-4 border border-gray-200 shadow-lg"
          >
            {navItems.map((item) => (
              <button
                key={item}
                onClick={() => smoothScrollTo(item)}
                className="block w-full text-left py-3 text-gray-700 hover:text-[#77c593] transition-colors font-medium"
              >
                {item}
              </button>
            ))}
          </motion.div>
        )}
      </div>
    </motion.header>
  )
}

export default Header
